module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/vlotterik/metabase/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/vlotterik/metabase/node_modules/source-map-loader/dist/cjs.js!/vlotterik/metabase/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}